import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { TransactionGetCoach } from "../Services/Transactions";
import { LoadingContext } from "../Context";
import { CoachImageType, CoachType } from "../Structures";
import { Modal } from "../Components/Modal";
import { formatTime, Toast } from "../Utils";
import { Empty } from "../Components/Base";

const Coach = () => {
  const navigate = useNavigate();
  const { loading, setLoading } = useContext(LoadingContext);
  const { id } = useParams<{ id: string }>();
  // =============================================================================================

  const [coach, setCoach] = useState<CoachType | undefined>();
  const [selectedAsset, setSelectedAsset] = useState<CoachImageType | null>(
    null
  );
  // =============================================================================================

  useEffect(() => {
    if (id) {
      setLoading(true);
      TransactionGetCoach(id)
        .then(({ data: res }) => {
          if (res.transaction_status) {
            setCoach(res.data);
          } else {
            navigate("/coachs");
            Toast("error", res.message);
          }
        })
        .finally(() => setLoading(false));
    } else {
      navigate("/");
    }
  }, []);

  // =============================================================================================

  return (
    <Fragment>
      <section className="pt-4">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12 col-lg-4 mb-3 mb-md-0">
                  <div
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
                    className="align-items-center gap-3 flex-column d-md-flex p-3 p-sm-4 text-center text-md-start rounded-3"
                  >
                    <div className="avatar mx-auto mb-3 mb-md-0 avatar-xxl">
                      <img
                        className="avatar-img rounded-circle border border-primary"
                        src={coach?.user.profile}
                        alt={coach?.user.fullname}
                      />
                    </div>

                    <div className="text-center">
                      <h2 className="m-0 fw-bold">{coach?.user.fullname}</h2>
                      <p className="mt-2 fw-bold">{coach?.position}</p>
                      <ul className="list-inline mt-2">
                        <li className="list-inline-item text-justify d-flex align-items-start">
                          <i className="bi bi-geo-alt me-1 d-flex justify-content-center align-items-center mt-1"></i>{" "}
                          {coach?.town.name} - {coach?.gymAddress}
                        </li>
                      </ul>
                      <a
                        download={true}
                        target="_blank"
                        href={coach?.resume}
                        className="btn btn-white text-primary"
                        onClick={(e) => {
                          if (!coach?.resume) {
                            e.preventDefault();
                            Toast(
                              "info",
                              "رزومه‌ای برای این مربی ثبت نشده است."
                            );
                          }
                        }}
                      >
                        مشاهده رزومه
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-8">
                  <div className="card border h-100">
                    <div className="card-header border-bottom p-3">
                      <h4 className="card-header-title mb-0">سانس های مربی</h4>
                    </div>
                    <div className="card-body">
                      <Empty
                        data={coach?.sans || []}
                        isLoading={loading}
                        description="در حال حاضری سانسی وجود ندارد"
                      >
                        <div className="d-flex w-100 justify-content-end">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <td scope="col">
                                  <span className="mx-2">شناسه</span>
                                </td>
                                <td scope="col">روز</td>
                                <td scope="col">ساعت شروع</td>
                                <td scope="col">ساعت پایان</td>
                              </tr>
                            </thead>
                            <tbody>
                              {coach?.sans.map((sans) => (
                                <tr
                                  style={{
                                    height: 50,
                                    verticalAlign: "middle",
                                  }}
                                  key={sans.id}
                                >
                                  <td className="mx-3">
                                    <span className="mx-2">{sans.id}</span>
                                  </td>
                                  <td>{sans.day}</td>
                                  <td>{formatTime(sans.start_time)}</td>
                                  <td>{formatTime(sans.end_time)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </Empty>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 position-relative pt-4">
              {coach?.images.length ? (
                <div className="container">
                  <h3>تصاویر مربی</h3>
                  <hr />
                  <div className="row filter-container overflow-hidden">
                    {coach?.images.map((image) => (
                      <div
                        onClick={() => setSelectedAsset(image)}
                        key={image.id}
                        className="col-sm-6 d-flex justify-content-center align-items-center cursor-pointer col-lg-4 grid-item"
                      >
                        <div className="card w-100 rounded-1 mb-4">
                          <div className="card-fold position-relative overflow-hidden rounded-1">
                            <img
                              className="card-img"
                              src={image.image}
                              alt="Gallery asset"
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
            </div>
            {selectedAsset ? (
              <Modal close={() => setSelectedAsset(null)}>
                <div className="z-index-99 bg-transparent overflow-hidden mw-520 mb-4">
                  <div className="card-fold overflow-hidden position-relative rounded-3">
                    <img
                      className="card-img"
                      src={selectedAsset.image}
                      alt="Card image"
                    />
                  </div>
                </div>
              </Modal>
            ) : null}
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Coach;
